import React from "react";
import classNames from "classnames";

// Components
import Paragraph from "../../../../../../Atoms/Paragraph";

// Stylesheets
import styles from "./style.module.scss";

// Utils
import {
  ImgixImage,
  ImgixPicture,
  ImgixSource,
} from "../../../../../../Utils/ImgixImage";

export const SubNavigationItemInfo = ({ info }) => {
  return (
    <div className={styles.subNavigationItemInfo}>
      {info.image ? (
        <ImgixPicture
          fallback={<ImgixImage src={info.image.src} alt={info.image.alt} />}
        >
          <ImgixSource src={info.image.src} width={1000} />
        </ImgixPicture>
      ) : null}
      {info.imageBadges ? (
        <div className={styles.subNavigationItemInfo_badges}>
          {info.imageBadges.map((badge, index) => (
            <div
              key={index}
              className={classNames(
                styles.subNavigationItemInfo_badge,
                badge.backgroundColor === "lightNavy"
                  ? styles.subNavigationItemInfo_badgeLightNavy
                  : ""
              )}
            >
              <Paragraph className="caption_secondary">{badge.title}</Paragraph>
            </div>
          ))}
        </div>
      ) : null}

      <Paragraph>{info.description}</Paragraph>
    </div>
  );
};

export default SubNavigationItemInfo;
